import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import { ImageV1 } from '@ilteducation/content-registry-types';
import truncate from 'lodash/truncate';
import { BaseState } from '@ilteducation/content-registry-types/enums/content-enums';
import ResourceImage from '@/components/base/ResourceImage.vue';
import useDownloadMedia from '@/comp/use-download-media';
import eventBus from '@/foundations/services/eventBus';
import ChipField from '@/components/base/ChipField.vue';
import useMediaFormFeature from '@/comp/use-media-form-feature';

type Props = {
  title: string;
  resource: unknown;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'List',
  props: {
    title: null,
    resource: null
  },
  setup(__props: any) {

const props = __props as {
  title: string;
  resource: unknown;
}

const { downloadMediaUrl } = useDownloadMedia();



const getStateColor = (state: string) => {
  switch (state) {
    case 'published':
      return 'green';
    case 'disabled':
      return 'red';
    default:
      return 'yellow';
  }
};

const fields = [
  { source: 'preview' },
  { source: 'id', link: 'edit', sortable: true },
  { source: 'description', label: 'Description' },
  { source: 'altText', type: 'boolean' },
  { source: 'state', sortable: true },
  {
    source: 'lastUpdatedAt',
    sortable: true,
  },
];

const filters = [
  {
    source: 'state',
    type: 'select',
    attributes: {
      multiple: true,
    },
  },
  {
    source: 'lastUpdatedAt',
    type: 'date',
  },
];

const isImageSelected = ref(false);
const selectedImage = ref<ImageV1 | null>(null);

const download = (id: string) => {
  downloadMediaUrl(id).then((url) => {
    if (url && url.length > 0) {
      window.open(url!, '_blank').focus();
    } else {
      eventBus.$emit('snackbar.open', `Failed to get download url`);
    }
  });
};

const truncateLongText = (text: string) => truncate(text, { length: 50, separator: '...' });

const openImagePreview = (item: ImageV1) => {
  isImageSelected.value = true;
  selectedImage.value = item;
};
const closeImagePreview = () => {
  isImageSelected.value = false;
  selectedImage.value = null;
};

const enableImages = async (books: ImageV1[]) => {
  const res = await Promise.allSettled(
    books
      .filter((image) => image.state === BaseState.Disabled)
      .map((image: ImageV1) => {
        const { toggleMediaState } = useMediaFormFeature(image);
        return toggleMediaState();
      }),
  );
  eventBus.$emit('snackbar.open', `Enabled ${res.length} images`);
};
const disableImages = async (books: ImageV1[]) => {
  const res = await Promise.allSettled(
    books
      .filter((image) => image.state === BaseState.Published)
      .map((image: ImageV1) => {
        const { toggleMediaState } = useMediaFormFeature(image);
        return toggleMediaState();
      }),
  );
  eventBus.$emit('snackbar.open', `Disabled ${res.length} images`);
};

return { __sfc: true,downloadMediaUrl, props, getStateColor, fields, filters, isImageSelected, selectedImage, download, truncateLongText, openImagePreview, closeImagePreview, enableImages, disableImages, ResourceImage, ChipField }
}

})